import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { DivisionRegistration } from '@reg/shared/model';
import { HttpServiceHelper } from '@reg/shared/service/http-service-helper';
import { IJsonApiResponse } from '../json-api/json-api.interface';

/**
 * Service used to get and and save a wrestling division's registration
 * data.
 */
@Injectable()
export class DivisionRegistrationService {
    public static INCLUDE_TEAMS_COACHES: string = 'teams.coaches';
    public static INCLUDE_DIVISION: string = 'division';

    /**
     * Constructor
     */
    constructor(private http: HttpServiceHelper) {
    }

    /**
     * Add or update the division's registration data
     */
    public save(registration: DivisionRegistration): Observable<DivisionRegistration> {
        const includes: string[] = [
            DivisionRegistrationService.INCLUDE_DIVISION,
            DivisionRegistrationService.INCLUDE_TEAMS_COACHES,
        ];
        let response: Observable<IJsonApiResponse>;
        const apiRequestUrl: string = this.getApiUrl(registration.eventId, registration.id, includes);

        if (registration.id) {
            // Update existing Division
            response = this.http.patch(apiRequestUrl, registration.serialize());
        } else {
            // Add a new Division
            response = this.http.post(apiRequestUrl, registration.serialize());
        }

        return response
            .pipe(
                map((response: IJsonApiResponse) => (new DivisionRegistration(registration.eventId, null))
                    .deserialize(response, response.included)),
            );
    }

    /**
     * Delete the division's registration data
     */
    public delete(eventId: string, divisionRegistrationId: string): Observable<boolean> {
        const apiRequestUrl: string = this.getApiUrl(eventId, divisionRegistrationId, null);
        return this.http.delete(apiRequestUrl).pipe(map((response: IJsonApiResponse) => true));
    }

    /**
     * Build the api's url base on the specified parameters
     */
    private getApiUrl(eventId: string, divisionRegistrationId: string, includes: string[]): string {
        let url: string = `${this.http.configService.getApiBaseUrl()}/events/${eventId}/division-registrations/`;

        if (divisionRegistrationId) {
            url += divisionRegistrationId;
        }

        url += this.http.getQueryParameters(includes);

        return url;
    }
}
